import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { FotoPerfil } from "../app/pages/configuracion-sistema/configuracion-foto-perfil/FotoPerfil";

@Injectable()
export class ConfiguracionSistemaService {

    private logoCliente: string;
    public logoClienteSubject = new BehaviorSubject(this.logoCliente);

    private fotoPerfil: FotoPerfil;
    public fotoPerfilSubject = new BehaviorSubject(this.fotoPerfil);

    changeLogoClienteSubject(logoCliente: string) {
        this.logoClienteSubject.next(logoCliente)
    }

    changeFotoPerfilSubject(fotoPerfil: FotoPerfil) {
        this.fotoPerfilSubject.next(fotoPerfil)
    }
}


// WEBPACK FOOTER //
// C:/Synergy/Projects/SFE/Synergy.UI/src/services/configuracion.sistema.service.ts